export default {"src":"/_next/static/media/logo_01.550a486d.svg","height":66,"width":108,"blurWidth":0,"blurHeight":0};